<template>
  <div class="video-loader inset-0 flex h-full w-full items-center justify-center">
    <Skeleton class="h-full w-full" />
  </div>
</template>

<script lang="ts" setup>
import Skeleton from '@ui/skeleton/Skeleton.vue';

interface Props {
  ratio?: number;
}

defineProps<Props>();
</script>

<style scoped lang="postcss">
.video-loader {
  aspect-ratio: v-bind('ratio');
}
</style>
